<app-title [title]="title"></app-title>

<p>
  Διαβάστε το πλήρες κείμενο του καταστατικού του Ενιαίου Παλλαϊκού Μετώπου όπως εγκρίθηκε και ψηφίσθηκε από το 9o
  Τακτικό Εθνικό Συνέδριο του κόμματος.
</p>

<div class="yumpu-container">
  <iframe src="https://www.yumpu.com/xx/embed/view/IrGcO4wMWTa7Y6jD" frameborder="0"></iframe>
</div>
